import { memo, useCallback, useContext, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Stack } from '@mui/material'
import ClearIcon from '../../../assets/icons/ClearIcon'
import { selectActiveChartId, selectChartReplayMode } from '../../../selectors/chart'
import { AppContext } from '../../../App'
import useStyles from './styles'
import { disableReplayMode, ReplayStatus, updateReplayModeState } from '../../../reducer/chart.reducer'
import { useDispatch } from 'react-redux'
import { ExtraSmallButton, NonInteractiveTooltip } from '../../custom'
import ReplaySpeedMenu from '../replaySpeedMenu/replaySpeedMenu'
import FastForwardIcon from '../../../assets/icons/FastForwardIcon'
import ForwardIcon from '../../../assets/icons/ForwardIcon'
import PlayIcon from '../../../assets/icons/PlayOutlineIcon'
import PauseIcon from '../../../assets/icons/PauseIcon'

type ChartReplayToolbarProps = {
    disable?: boolean
}
const ChartReplayToolbar = ({ }: ChartReplayToolbarProps) => {
    const dispatch = useDispatch();
    const activeChartId = useSelector(selectActiveChartId)
    const appContext = useContext(AppContext)
    const replayManager = appContext.replayManager;
    const { classes } = useStyles()

    const replayModeState = useSelector(selectChartReplayMode)

    const playing = useMemo(() => replayModeState?.status === ReplayStatus.PLAYING, [replayModeState])

    const onPlayClick = useCallback(() => {
        dispatch(updateReplayModeState({
            status: ReplayStatus.PLAYING
        }))
        replayManager.play();
    }, [replayManager])

    const onPauseClick = useCallback(() => {
        dispatch(updateReplayModeState({
            status: ReplayStatus.SELECTED
        }))
        replayManager.stop();
    }, [replayManager])

    const onFastForwardClick = useCallback(() => {
        replayManager.disableReplayMode();
        dispatch(disableReplayMode())
    }, [replayManager])

    const onForwardClick = useCallback(() => {
        replayManager.gotoNextCandle();
    }, [replayManager])



    if (!replayModeState) return null;

    return (
        <div className={classes.container}>
            <Stack direction="row" sx={{ width: '100%', alignItems: 'center' }}>
                <Stack direction="row" sx={{ flex: 1, minWidth: 0 }} />
                <Stack direction="row" spacing={0.5}>
                    {!playing &&
                        <NonInteractiveTooltip title={'Play'} arrow placement='top'>
                            <ExtraSmallButton onClick={onPlayClick}>
                                <PlayIcon />
                            </ExtraSmallButton>
                        </NonInteractiveTooltip>
                    }
                    {playing &&
                        <NonInteractiveTooltip title={'Pause'} arrow placement='top'>
                            <ExtraSmallButton onClick={onPauseClick} variant="contained" color="primary">
                                <PauseIcon />
                            </ExtraSmallButton></NonInteractiveTooltip>}

                    <ReplaySpeedMenu />
                    <NonInteractiveTooltip title={'Forward'} arrow placement='top'><ExtraSmallButton onClick={onForwardClick}  >
                        <ForwardIcon />
                    </ExtraSmallButton>
                    </NonInteractiveTooltip>
                    <NonInteractiveTooltip title={'Jump to real-time chart'} arrow placement='top'>
                        <ExtraSmallButton onClick={onFastForwardClick} >
                            <FastForwardIcon />
                        </ExtraSmallButton>
                    </NonInteractiveTooltip>
                </Stack>
                <Stack direction="row" sx={{ flex: 1, justifyContent: 'flex-end', minWidth: 0, paddingRight: 2 }}>
                    <NonInteractiveTooltip title={'Close replay'} arrow placement='top'>
                    <ExtraSmallButton onClick={onFastForwardClick} aria-label="Close replay">
                        <ClearIcon />
                    </ExtraSmallButton>
                </NonInteractiveTooltip>
                </Stack>
            </Stack>
        </div>
    )
}

export default memo(ChartReplayToolbar)